import { defineMessages } from "react-intl";

export const LocalizationMessages = defineMessages({
    AccountDetailsLink: {
        defaultMessage: "Account Details",
        id: "account.details.link.text"
    },
    accountStatement: {
        defaultMessage: "Account Statement",
        id: "account.statement.text"
    },
    accountHistory: {
        defaultMessage: "Win Loss History",
        id: "account.history.text"
    },
    allSports: {
        defaultMessage: "All Sports",
        id: "allSports.text"
    },
    app:{
        defaultMessage: "App",
        id: "app.text"
    },
    appUpgradeRequiredPopupButton: {
        defaultMessage: "Update app",
        id: "appUpgradeRequiredPopupButton.text"
    },
    appUpgradeRequiredPopupTitle: {
        defaultMessage: "Title",
        id: "appUpgradeRequiredPopupTitle.text"
    },

    appUpgradeRequiredPopupContentSubTitle: {
        defaultMessage: "We have upgraded our app. ",
        id: "appUpgradeRequiredPopupSubtitle.text"
    },   
    appUpgradeRequiredPopupContent: {
        defaultMessage: "Click below to download the latest version and login",
        id: "appUpgradeRequiredPopupContent.text"
    },    
    betFeed: {
        id: "betFeed.text"
    },
    betNow: {
        defaultMessage: "Bet Now",
        id: "betNow.text"
    },
    bettingHistory: {
        defaultMessage: "Sport History",
        id: "bettinghistory.text"
    },
    bettingHistorySpectate: {
        defaultMessage: "Sport History",
        id: "bettinghistoryspecate.text"
    },
    bettingRules: {
        defaultMessage: "BettingRules",
        id: "bettingrules.text"
    },
    blog: {
        id: "blog.text"
    },
    boldLive: {
        id: "boldLive.text"
    },
    bonusBalance: {
        defaultMessage: "Bonus Balance:",
        id: "bonusbalance.text"
    },
    buttonCancel: {
        id: "button.cancel.text"
    },
    buttonClose: {
        defaultMessage: "CLOSE",
        id: "button.close.text"
    },
    buttonOk: {
        id: "button.ok.text"
    },
    buttonConfirm: {
        defaultMessage: "Confirm",
        id: "button.confirm.text"
    },
    buttonYes: {
        defaultMessage: "Yes",
        id: "button.yes.text"
    },
    cashBalance: {
        defaultMessage: "Cash Balance:",
        id: "cashbalance.text"
    },
    cashier: {
        id: "cashier.text"
    },
    challenges: {
        defaultMessage: "Challenges",
        id: "challenges.text"
    },
    challenges_brand_8: {
        defaultMessage: "Challenges",
        id: "challenges_brand8.text"
    },
    challenges_brand_8_mobile: {
        defaultMessage: "Challenges",
        id: "challenges_brand8_mobile.text"
    },
    confirmLocationPopupTitle: {
        id: "confirmLocation.popup.title.text"
    },
    confirmLocationPopupContentP1: {
        id: "confirmLocation.popup.content.p1.text"
    },
    confirmLocationPopupContentP2: {
        id: "confirmLocation.popup.content.p2.text"
    },
    confirmLocationPopupFooter: {
        id: "confirmLocation.popup.footer.text"
    },
    contactUs: {
        defaultMessage: "Contact Us",
        id: "contactus.text"
    },
    biometricsSettings: {
        defaultMessage: "Biometric Login",
        id: "biometricsSettings.text"
    },
    biometricsSettings_58: {        
        id: "biometricsSettings_58.text"
    },
    biometricsEnrolled: {
        defaultMessage: "ON",
        id: "biometricsEnrolled.text"
    },
    biometricsNotEnrolled: {
        defaultMessage: "OFF",
        id: "biometricsNotEnrolled.text"
    },
    deposit: {
        defaultMessage: "Deposit",
        id: "deposit.text"
    },
    depositAndCashout: {
        defaultMessage: "Deposit & Cashout",
        id: "depositAndCashout.text"
    },
    depositLimits: {
        defaultMessage: "Deposit Limits",
        id: "depositLimits.text"
    },
    DisclaimerLine1: {
        defaultMessage: "Enabling Touch ID feature on this device will allow anyone whose fingerprint is saved on this device to gain full access to your 888 account. You should not proceed to set up this feature if any fingerprint in addition to your own are stored on this device.",
        id: "DisclaimerLine1.text"
    },
    DisclaimerLine2: {
        defaultMessage: "By using Touch ID to access your 888 account, you agree that you are solely responsible for all transactions on your account, regardless if such transactions are made by a third party or any person with a fingerprint saved on this device.",
        id: "DisclaimerLine2.text"
    },
    DisclaimerLine3: {
        defaultMessage: "In addition, you agree that the operator of the application and its affiliates (together the 888 Group) shall not be liable to you for any consequences arising from using Touch ID to access your 888 account. The 888 Group shall not be held responsible for any loss, liability, damage, expenses or costs incurred through the use of this feature.",
        id: "DisclaimerLine3.text"
    },
    DisclaimerLine4: {
        defaultMessage: "For each 888 application which you have on your device, only one of your accounts can be configured to login with Touch ID at any point in time.",
        id: "DisclaimerLine4.text"
    },
    DisclaimerLine5: {
        defaultMessage: "You will be required to login using your password when Touch ID authentication fails or expires.",
        id: "DisclaimerLine5.text"
    },
    DisclaimerLine6: {
        defaultMessage: "888 Group does not store your fingerprint on its servers and does not handle or support Touch ID technology.",
        id: "DisclaimerLine6.text"
    },
    DisclaimerLink: {
        defaultMessage: "By enabling the Touch ID feature you agree to the terms and conditions.",
        id: "DisclaimerLink.text"
    },
    downloadApp: {
        id: "downloadApp.text"
    },
    faceIdHeader: {
        defaultMessage: "Login with Face ID",
        id: "faceIdHeader.text"
    },
    financialStatus: {
        defaultMessage: "Financial",
        id: "financial.status.text"
    },
    gameFrameTitle: {
        defaultMessage: "Game",
        id: "gameframe.header.title"
    },
    gamingHistory: {
        defaultMessage: "gaming",
        id: "gaming.history.text"
    },
    geolocationCheckingLocationError: {
        defaultMessage: "Unfortunately an error has occurred when checking your location.",
        id: "geolocationCheckingLocationError.text"
    },
    geolocationConfirmYourLocationP1: {
        defaultMessage: "Per regulations, we must verify your location to allow you to bet on 888sport.",
        id: "geolocationConfirmYourLocationP1.text"
    },
    geolocationConfirmYourLocationP1_si: {
        defaultMessage: "Per regulations, we must verify your location to allow you to bet on SI Sportsbook.",
        id: "geolocationConfirmYourLocationP1_si.text"
    },
    geoComplyRequiredTitle: {
        defaultMessage: "Location Check",
        id: "geoComplyRequiredTitle.text"
    },
    geoComplyRequiredP1: {
        defaultMessage: "Verify your location",
        id: "geoComplyRequiredP1.text"
    },
    geoComplyRequiredP2: {
        defaultMessage: "This site is dedicated for players in USA permitted states",
        id: "geoComplyRequiredP2.text"
    },
    geoComplyRequiredP3: {
        defaultMessage: "To verify your location and start playing, please install the",
        id: "geoComplyRequiredP3.text"
    },
    geoComplyRequiredP4: {
        defaultMessage: "GeoComply plugin:",
        id: "geoComplyRequiredP4.text"
    },
    geoComplyRequiredStep1: {
        defaultMessage: "Click the Download Plugin button below",
        id: "geoComplyRequiredStep1.text"
    },
    geoComplyRequiredStep2: {
        defaultMessage: "Open the file from the download bar",
        id: "geoComplyRequiredStep2.text"
    },
    geoComplyRequiredStep3: {
        defaultMessage: "Click Run to install the file",
        id: "geoComplyRequiredStep3.text"
    },
    geoComplyDownloadPlugin: {
        defaultMessage: "Download",
        id: "geoComplyDownloadPlugin.text"
    },
    geoComplyReDownloadPlugin: {
        defaultMessage: "Need to redownload the plugin?",
        id: "geoComplyReDownloadPlugin.text"
    },
    geolocationLocationAlert: {
        defaultMessage: "Location Alert",
        id: "geolocationLocationAlert.text"
    },
    geolocationProcessPopupP1: {
        defaultMessage: "Verifying...",
        id: "geolocationProcess.popup.p1.text"
    },
    geolocationProcessPopupP2: {
        defaultMessage: "We are checking that you are currently located in the state of {state}.",
        id: "geolocationProcess.popup.p2.text"
    },
    geolocationLocationCheckTitle: {
        defaultMessage: "Location Check",
        id: "geolocationLocationCheckTitle.text"
    },
    geolocationConfirmedP1: {
        defaultMessage: "Completed",
        id: "geolocationConfirmed.popup.p1.text"
    },
    geolocationConfirmedP2: {
        defaultMessage: "We have confirmed that you are in the state of {state}.",
        id: "geolocationConfirmed.popup.p2.text"
    },
    geolocationLocationConfirmedTitle: {
        defaultMessage: "Location Confirmed",
        id: "geolocationLocationConfirmedTitle.text"
    },
    geolocationLocationNotConfirmedTitle: {
        defaultMessage: "Location Not Confirmed",
        id: "geolocationLocationNotConfirmedTitle.text"
    },
    geolocationLocationMobilePermissionsTittle: {
        defaultMessage: "Location Check",
        id: "geolocationLocationRequiredTittle.text"
    },
    geolocationLocationMobilePermissionsP1: {
        defaultMessage: "Allow location verification",
        id: "geolocationLocationMobilePermissionsP1.text"
    },
    geolocationLocationMobilePermissionsP2: {
        defaultMessage: "We need your location to verify that",
        id: "geolocationLocationMobilePermissionsP2.text"
    },
    geolocationLocationMobilePermissionsP3: {
        defaultMessage: "playing is allowed in your province",
        id: "geolocationLocationMobilePermissionsP3.text"
    },
    geolocationLocationMobilePermissionsP3_si: {
        defaultMessage: "playing is allowed in your state",
        id: "geolocationLocationMobilePermissionsP3_si.text"
    },
    geolocationLogoutRequiredContent: {
        defaultMessage: "We now require you to log out and to log back in to your account for these changes to take effect.",
        id: "geolocationLogoutRequiredContent.text"
    },
    geolocationLogoutRequiredTitle: {
        defaultMessage: "Thanks For Installing The Browser Plugin",
        id: "geolocationLogoutRequiredTitle.text"
    },
    geolocationNotInAreaText: {
        defaultMessage: "We have detected that you are located outside of Canada. Some features will be limited on your account.",
        id: "geolocationNotInAreaText.text"
    },
    geolocationNotInAreaText_si: {
        defaultMessage: "We have detected that you are located outside of the USA. Some features will be limited on your account.",
        id: "geolocationNotInAreaText_si.text"
    },
    help: {
        id: "help.text"
    },
    helpCenter: {
        id: "helpCenter.text"
    },
    historySectionTitle: {
        defaultMessage: "History",
        id: "userarea.section.title.text"
    },
    home: {
        id: "homeSection.text"
    },
    language: {
        id: "languages.text"
    },
    lastLogin: {
        defaultMessage: "Last Login:",
        id: "lastlogin.text"
    },
    liveChat: {
        defaultMessage: "Chat Live",
        id: "livechat.text"
    },
    liveNow: {
        id: "liveRightNow.text"
    },
    liveNowSpectate: {
        id: "liveRightNowSpectate.text"
    },
    login: {
        id: "login.text"
    },
    logoutPopupContent: {
        id: "logout.content.text"
    },
    logoutPopupTitle: {
        id: "logout.title.text"
    },
    logoutText: {
        defaultMessage: "Log Out",
        id: "logout.text"
    },
    lowFundsPopupTitle: {
        id: "lowfunds.title.text"
    },
    lowFundsPopupContent: {
        id: "lowfunds.content.text"
    },
    lowFundsPopupButtonDeposit: {
        id: "lowfunds.button.deposit"
    },
    migrationContinue: {
        defaultMessage: "Fortfahren",
        id: "migration.popup.button.continue"
    },
    migrationPopupContent: {
        defaultMessage: "Willkommen bei der neuen deutschen Website von 888sport!\nWenn Sie bereits ein Konto bei 888Sport besitzen, können Sie sich mit\nIhren Anmeldeinformationen einloggen oder auch ein neues Konto\neröffnen.",
        id: "migration.content.text"
    },
    migrationPopupFooter: {
        defaultMessage: "*Aufgrund rechtlicher Änderungen in Deutschland steht 888sport.com\nin Deutschland nicht länger zur Verfügung.",
        id: "migration.footer.text"
    },
    migrationPopupTitle: {
        defaultMessage: "Willkommen!",
        id: "migration.title.text"
    },
    myAccount: {
        defaultMessage: "My Account",
        id: "myaccount.text"
    },
    myGameHistory: {
        defaultMessage: "My Game History",
        id: "myGameHistory.text"
    },
    myBets: {
        defaultMessage: "My Bets",
        id: "mybets.text"
    },
    mySettings: {
        defaultMessage: "My Settings",
        id: "mysettings.text"
    },
    notifications: {
        defaultMessage: "Notifications",
        id: "notifications.text"
    },
    odds: {
        defaultMessage: "Odds",
        id: "odds.text"
    },
    odds_58: {        
        id: "odds_58.text"
    },
    oddsFormatTitle: {
        defaultMessage: "Choose your preferred odds format",
        id: "odds.title.text"
    },
    oddsFormatTitle_58: {       
        id: "odds.title_58.text"
    },
    onlineHelp: {
        defaultMessage: "Online Help",
        id: "onlinehelp.text"
    },
    openNativeSport888: {
        id: "openNativeSport888.text"
    },
    panicMessageButton: {
        defaultMessage: "24-stündige Sperre",
        id: "panic.message.button"
    },
    panicMessageContent: {
        defaultMessage: "Um eine 24-stündige Wettpause einzulegen, ",
        id: "panic.message.content.text"
    },
    panicMessageLink: {
        defaultMessage: "klicken Sie hier.",
        id: "panic.message.link"
    },
    panicOk: {
        defaultMessage: "OK",
        id: "panic.popup.button.ok"
    },
    panicPopupContentPartOne: {
        defaultMessage: "Sie haben sich für eine 24-stündige Pause entschieden.\nSie können das Wetten morgen um ",
        id: "panic.contentOne.text"
    },
    panicPopupContentPartTwo: {
        defaultMessage: " wieder aufnehmen.",
        id: "panic.contentTwo.text"
    },
    panicPopupTitle: {
        defaultMessage: "24-Stündige Pause",
        id: "panic.title.text"
    },
    personalAreaGoodAfternoon: {
        defaultMessage: "Good Afternoon",
        id: "goodAfternoonPersonalArea.text"
    },
    personalAreaGoodEvening: {
        defaultMessage: "Good Evening",
        id: "goodEveningPersonalArea.text"
    },
    personalAreaGoodMorning: {
        defaultMessage: "Good Morning",
        id: "goodMorningPersonalArea.text"
    },
    personalAreaHello: {
        defaultMessage: "Hello",
        id: "helloPersonalArea.text"
    },
    personalAreaTitle: {
        defaultMessage: "My personal area",
        id: "mypersonalarea.text"
    },
    personalLimitsTitle: {
        defaultMessage: "Your Limits",
        id: "personalLimitsTitle.text"
    },
    personalLimitsDeposit: {
        defaultMessage: "Deposit",
        id: "personalLimitsDeposit.text"
    },
    personalLimitsPlaytime: {
        defaultMessage: "Play time",
        id: "personalLimitsPlaytime.text"
    },
    personalLimitsPlaytimeHours: {
        defaultMessage: "hours",
        id: "personalLimitsPlaytimeHours.text"
    },
    personalLimitsBankroll: {
        defaultMessage: "Bankroll",
        id: "personalLimitsBankroll.text"
    },
    personalLimitsDaily: {
        defaultMessage: "Daily",
        id: "personalLimitsDaily.text"
    },
    personalLimitsWeekly: {
        defaultMessage: "Weekly",
        id: "personalLimitsWeekly.text"
    },
    personalLimitsMonthly: {
        defaultMessage: "Monthly",
        id: "personalLimitsMonthly.text"
    },
    pokerHistory: {
        defaultMessage: "Poker History",
        id: "pokerHistory.text"
    },
    popupNotNow: {
        defaultMessage: "Not now",
        id: "popup.notNow.text"
    },
    popupOverlayContinue: {
        defaultMessage: "Continue",
        id: "popup.overlay.continue.text"
    },
    popupOverlayDescription: {
        defaultMessage: "Click continue to bring it back.",
        id: "popup.overlay.description.text"
    },
    popupOverlayHeader: {
        defaultMessage: "Can’t see the window?",
        id: "popup.overlay.header.text"
    },
    poweredBy888Casino: {
        defaultMessage: "Powered by 888casino",
        id: "poweredby888casino.text"
    },
    poweredBy888poker: {
        defaultMessage: "Powered by 888poker",
        id: "poweredby888poker.text"
    },
    poweredBy888Sport: {
        defaultMessage: "Powered by 888sport",
        id: "poweredby888sport.text"
    },
    privacyPolicy: {
        defaultMessage: "Privacy Policy",
        id: "privacypolicy.text"
    },
    promotions: {
        id: "ourOffers.text"
    },
    offers: {
        id: "welcomeOffers.text"
    },
    offersAuthenticated: {
        id: "welcomeOffersAuthenticated.text"
    },
    promotionsVIP: {
        defaultMessage: "VIP",
        id: "ourOffersVip.text"
    },
    challengesMenuLabel : {
        defaultMessage: "Challenges",
        id: "challengesMenuLabel.text" 
    },
    realityCheckContinue: {
        id: "realityCheck.popup.button.continue"
    },
    realityCheckDisclamer: {
        id: "realityCheck.popup.disclamer"
    },
    realityCheckHeader: {
        id: "realityCheck.popup.header"
    },
    realityCheckLogoutButton: {
        id: "realityCheck.popup.button.logout"
    },
    realityCheckLose: {
        id: "realityCheck.popup.lose"
    },
    realityCheckPlaytime: {
        id: "realityCheck.popup.playtime"
    },
    realityCheckWin: {
        id: "realityCheck.popup.win"
    },
    recommendations: {
        id: "recommendations.text"
    },
    recommendationsSpectate: {
        id: "recommendationsSpectate.text"
    },
    remindMeLater: {
        defaultMessage: "Remind Me Later",
        id: "remindMeLater.txt"
    },
    madeForYou: {
        id: "madeForYou.text"
    },
    madeForYouES: {
        id: "madeForYou.8.text"
    },
    redirectMftTitle: {
        defaultMessage: "Deposit in process",
        id: "redirectMft.popup.title"
    },
    redirectMftContent: {
        defaultMessage: "Your {mft} screen is still open",
        id: "redirectMft.popup.content.text"
    },
    redirectMftButton: {
        defaultMessage: "CONTINUE",
        id: "redirectMft.popup.button.continue"
    },
    register: {
        id: "register.text"
    },
    registerButtonText: {
        defaultMessage: "Register",
        id: "registerButton.text"
    },
    regulationLoginToastTitle:{
        defaultMessage: "Welcome",
        id:"regulation.login.toast.title.text"
    },
    regulationLoginToastMessageWin:{
        defaultMessage: "Your deposit limits are: Daily: {dailyLimit}, Weekly: {weeklyLimit}, Monthly: {monthlyLimit}. Total winnings in the last 12 months: {total}",
        id:"regulation.login.toast.message.win"
    },
    regulationLoginToastMessageNoLimitsWin:{
        defaultMessage: "Total winnings in the last 12 months: {total}. Open cashier to view your deposit limits",
        id:"regulation.login.toast.message.no.limits.win"
    },
    regulationLoginToastMessageLoss:{
        defaultMessage: "Your deposit limits are: Daily: {dailyLimit}, Weekly: {weeklyLimit}, Monthly: {monthlyLimit}. Total losses in the last 12 months: {total}",
        id:"regulation.login.toast.message.loss"
    },    
    regulationLoginToastMessageNoLimitsLoss:{
        defaultMessage: "Total losses in the last 12 months: {total}. Open cashier to view your deposit limits",
        id:"regulation.login.toast.message.no.limits.loss"
    },
    regulationLoginToastMessageNoLossData:{
        defaultMessage: "Your deposit limits are: Daily: {dailyLimit}, Weekly: {weeklyLimit}, Monthly: {monthlyLimit}. Open cashier to view your total losses in the last 12 months",
        id:"regulation.login.toast.message.no.loss.data"
    },  
    regulationLoginToastMessageNoData:{
        defaultMessage: "Open cashier to view your deposit limits your total losses in the last 12 months",
        id:"regulation.login.toast.message.no.data"
    },
    regulationLoginToastLink:{
        defaultMessage: "Link",
        id:"regulation.login.toast.link"
    },
    reports: {
        defaultMessage: "Reports",
        id: "reports.text"
    },
    responsibleGaming: {
        defaultMessage: "Responsible Gaming",
        id: "responsiblegaming.text"
    },
    responsibleGamingExternal: {
        defaultMessage: "Responsible Gaming",
        id: "responsiblegamingexternal.text"
    },
    RestrictionContent: {
        defaultMessage: "We were unable to open the game, please contact support.",
        id: "RestrictionContent.text"
    },
    RestrictionTitle: {
        defaultMessage: "Oops",
        id: "RestrictionTitle.text"
    },
    reversewithdrawal: {
        id: "reversewithdrawal.deeplink"
    },
    rewards: {
        id: "rewards.text"
    },
    technicalProblemBody: {
        defaultMessage: "Sorry, something went wrong.",
        id: "rightsidedrawer.error.body"
    },
    technicalProblemHeader: (appID,theme) => ({
        defaultMessage: "Oops",
        id: `rightsidedrawer.error.header.${(appID||"unknown").toLowerCase()}${theme? `.${theme?.toLocaleLowerCase()}` : ""}`
    }),
    technicalProblemButton: {
        defaultMessage: "Tap to retry",
        id: "rightsidedrawer.error.retry"
    },
    technicalProblemTitle: {
        defaultMessage: "Can't connect",
        id: "rightsidedrawer.error.title"
    },
    controlCenterIconTitle: theme =>  ({
        defaultMessage: "Safer Gambling Tools & Information",
        id:  `controlcenter.icon${theme ? `.${theme.toLocaleLowerCase()}` : ""}.title` 
    }),
    searchClear: {
        defaultMessage: "Clear",
        id: "search.clear.text"
    },
    searchNoResults: {
        defaultMessage: "No search results were found...",
        id: "search.noresults.text"
    },
    searchPlaceholder: {
        defaultMessage: "Search Sports, Leagues or Teams",
        id: "search.placeholder.text"
    },
    searchRecent: {
        defaultMessage: "Recent Searches",
        id: "search.recent.text"
    },
    searchResults: {
        defaultMessage: "Search results",
        id: "search.results.text"
    },
    searchResultsBack: {
        defaultMessage: "Back",
        id: "button.back.text"
    },
    searchResultsTypeLeague: {
        defaultMessage: "League",
        id: "search.results.type.league"
    },
    searchResultsTypeRegion: {
        defaultMessage: "Region",
        id: "search.results.type.region"
    },
    secondaryMenuCasino: {
        id: "casino.83.text"
    },
    secondaryMenuCasinoHistory: {
        id: "casinoHistory.83.text"
    },
    seeLess: {
        defaultMessage: "See Less",
        id: "menu.seeLess.text"
    },
    seeMore: {
        defaultMessage: "See More",
        id: "menu.seeMore.text"
    },
    selfExclusion: {
        defaultMessage: "Self Exclusion",
        id: "selfExclusion.text"
    },
    sessionTime: {
        defaultMessage: "Session Time:",
        id: "sessiontime.text"
    },
    startingSoon: {
        id: "startingSoon.text"
    },
    startingSoonSpectate: {
        id: "startingSoonSpectate.text"
    },
    themeMode: {
        defaultMessage: "Appearance",
        id: "themeMode.text"
    },
    themeModeChecklistTitle: {
        defaultMessage: "Choose your appearance mode:",
        id: "themeMode.checklist.title.text"
    },
    themeModeChecklistTitle_58: {
        defaultMessage: "Choose your appearance mode:",
        id: "themeMode.checklist.title_58.text"
    },
    themeModeCode1: {
        defaultMessage: "Always Dark",
        id: "themeMode.code1.text"
    },
    themeModeCode2: {
        defaultMessage: "Always Light",
        id: "themeMode.code2.text"
    },
    stateSelector: {
        id: "stateSelector.text"
    },
    stateSelector_si: {
        id: "stateSelector_si.text"
    },
    stateSelectorSelectDefaultText: {
        id: "stateSelector.select.default.text"
    },
    stateSelectorPopupContent: {
        defaultMessage: "Please confirm that you're located in {state}",
        id: "stateSelector.popup.content.text"
    },
    stateSelectorPopupContent_si: {
        id: "stateSelector.popup.content_si.text"
    },
    stateSelectorPopupFooter: {
        id: "stateSelector.popup.footer.text"
    },
    stateSelectorPopupTitle: {
        id: "stateSelector.popup.title.text"
    },
    stateSelectorContentPopupP1: {
        id: "stateSelector.popup.content.p1.text"
    },
    stateSelectorContentPopupP2: {
        id: "stateSelector.popup.content.p2.text"
    },
    supportId: {
        id: "supportId.text"
    },
    survey: {
        defaultMessage: "Up for 8",
        id: "survey.text"
    },
    surveyDK: {
        id: "survey.75.text"
    },
    surveyDKMRG: {
        id: "survey.94.text"
    },
    surveyES: {
        id: "survey.58.text"
    },
    surveyIT: {
        id: "survey.31.text"
    },
    surveyRO: {
        id: "survey.76.text"
    },
    menuItemTag: {
        defaultMessage: "New",
        id: "menuItemTag.text"
    },
    menuItemTagES: {
        defaultMessage: "New",
        id: "menuItemTag.58.text"
    },
    menuItemTagRO: {
        defaultMessage: "Gratuit",
        id: "menuItemTag.76.text"
    },

    downloadPokerPopupTitle: {
        id: "downloadpoker.title.text"
    },
    downloadPokerPopupContent: {
        id: "downloadpoker.content.text"
    },
    buttonDownload: {
        id: "button.download.text"
    },

    timeoutAndKickPopupContent: {
        id: "timeoutandkick.content.text"
    },
    timeoutAndKickPopupTimeLimitDaily: {
        id: "timeoutandkick.daily.text"
    },
    timeoutAndKickPopupTimeLimitMonthly: {
        id: "timeoutandkick.monthly.text"
    },
    timeoutAndKickPopupTimeLimitWeekly: {
        id: "timeoutandkick.weekly.text"
    },
    timeoutAndKickPopupTitle: {
        id: "timeoutandkick.title.text"
    },
    timeoutAndKickPopupDuplicateLogins:{
        defaultMessage: "You've been disconnected due to duplicate logins.",
        id: "timeoutandkick.duplicatelogin.text"
    },
    timeSpentReminderPopupButton: {
        id: "timespentreminder.popup.button.ok",
        defaultMessage: "GOT IT"
    },
    timeSpentReminderPopupContentPlaytime: {
        id: "timespentreminder.playtime.text",
        defaultMessage: "You have been logged in for:"
    },
    timeSpentReminderPopupContentTotalWinnings: {
        id: "timespentreminder.totalwins.text",
        defaultMessage: "Your total wins:"
    },
    timeSpentReminderPopupContentTotalLosses: {
        id: "timespentreminder.totallosses.text",
        defaultMessage: "Your total losses:"
    },
    timeSpentReminderPopupWagerAmount: {
        id: "timespentreminder.wageramount.text",
        defaultMessage: "Your wager amount:"
    },
    timeSpentReminderPopupContentTitle: {
        id: "timespentreminder.content.title.text",
        defaultMessage: "Stay in control of your game!"
    },
    timeSpentReminderPopupTitle: {
        id: "timespentreminder.title.text",
        defaultMessage: "Reminder"
    },
    titleRaces: {
        id: "titleRaces.text"
    },
    touchIdHeader: {
        defaultMessage: "Login with Touch ID",
        id: "touchIdHeader.text"
    },
    touchIdSave: {
        defaultMessage: "Save",
        id: "touchIdSave.text"
    },
    touchIdSuccessSave: {
        defaultMessage: "Successfully saved",
        id: "touchIdSuccessSave.text"
    },
    transactionHistory: {
        defaultMessage: "Transaction History",
        id: "transactionhistory.text"
    },
    uploadDocumentsButton: {
        id: "uploadDocuments.button.text"
    },
    uploadDocumentsDeeplink: {
        id: "uploadDocuments.deeplink"
    },
    uploadDocumentsPopupContent: {
        id: "uploadDocuments.content.text"
    },
    uploadDocumentsPopupContentV2: {
        id: "uploadDocuments.content.text.v2"
    },
    uploadDocumentsPopupMain: {
        id: "uploadDocuments.main.text"
    },
    uploadDocumentsPopupTitle: {
        id: "uploadDocuments.title.text"
    },
    uploadDocumentsPopupTitleV2: {
        id: "uploadDocuments.title.text.v2"
    },
    useFullLinksTitle: {
        defaultMessage: "Useful Links",
        id: "usefullinks.text"
    },
    userAgreement: {
        defaultMessage: "User Agreement",
        id: "useragreement.text"
    },
    userId: {
        defaultMessage: "User ID",
        id: "userId.text"
    },
    virtualSportText: {
        defaultMessage: "Virtual Sports",
        id: "virtualSports.text"
    },
    welcome: {
        defaultMessage: "Welcome",
        id: "greeting.welcome.text"
    },
    withdraw: {
        defaultMessage: "Withdraw",
        id: "withdraw.text"
    },
    yourBalance: {
        defaultMessage: "Your Balance",
        id: "yourbalance.text"
    },
    timeSpentCheckDisclamer: {
        defaultMessage: "",
        id: "timeSpent.popup.disclamer"
    },
    timeSpentReminderPopupLogOut: {
        defaultMessage: "LogOut",
        id: "timeSpentReminder.Popup.LogOut.text"
    },
    activityHistoryPopupTitle: {
        defaultMessage: "Welcome Back",
        id: "activityHistory.popup.title.text"
    },
    activityHistoryPopupContent: {
        defaultMessage: "Your 888sports activity",
        id: "activityHistory.popup.content.text"
    },
    activityHistoryPopupButtonBettingHistory: {
        defaultMessage: "Betting History",
        id: "activityHistory.popup.button.bettingHistory.text"
    },
    activityHistoryPopupButtonCashier: {
        defaultMessage: "Cashier",
        id: "activityHistory.popup.button.cashier.text"
    },
    activityHistoryPopupButtonBetNow: {
        defaultMessage: "Bet now",
        id: "activityHistory.popup.button.betNow.text"
    },
    showPlayerWinLossPopupTitle: {
        defaultMessage: "Login Information",
        id: "showPlayerWinLoss.popup.title.text"
    },
    showPlayerWinLossPopupSummary: {
        defaultMessage: "30 days summary",
        id: "showPlayerWinLoss.popup.summary.text"
    },
    showPlayerWinLossPopupBet: {
        defaultMessage: "Bet:",
        id: "showPlayerWinLoss.popup.bet.text"
    },
    showPlayerWinLossPopupWinLose: {
        defaultMessage: "Win/Lose:",
        id: "showPlayerWinLoss.popup.winLose.text"
    },
    showPlayerWinLossPopupApiError: {
        defaultMessage: "Data not available",
        id: "showPlayerWinLoss.popup.apiError.text"
    },
    seoLogoText: {
        defaultMessage: "betting",
        id: "seoLogoText.text"
    },
    howToPlay: {
        defaultMessage: "How to Play",
        id: "howToPlay.text"
    },
    games: {
        defaultMessage: "Games",
        id: "games.text"
    },
    specialOffers: {
        defaultMessage: "Special Offers",
        id: "specialOffers.text"
    },
    tournamentInfo: {
        defaultMessage: "Tournament info",
        id: "tournamentInfo.text"
    },
    realMoneyPoker: {
        defaultMessage: "Real Money Poker",
        id: "realMoneyPoker.text"
    },
    eMagazine: {
        defaultMessage: "eMagazine",
        id: "eMagazine.text"
    },
    howDeposit_Poker: {
        defaultMessage: "How to deposit",
        id: "howDeposit_Poker.text"
    },
    inviteFriend_Poker: {
        defaultMessage: "Invite a friend",
        id: "inviteFriend_Poker.text"
    },
    aboutUs_Poker: {
        defaultMessage: "About us",
        id: "aboutUs_Poker.text"
    },
    supportInformation_Poker: {
        defaultMessage: "Support information",
        id: "supportInformation_Poker.text"
    },
    tickets_Poker: {
        defaultMessage: "Tickets",
        id: "tickets_Poker.text"
    },
    blast_LeaderBoard_Poker: {
        defaultMessage: "Blast Leader board",
        id: "blast_LeaderBoard_Poker.text"
    },
    freeSpins_Poker: {
        defaultMessage: "Free Spin",
        id: "freeSpins_Poker.text"
    },
    redeemGoldTokens_Poker: {
        defaultMessage: "Redeem Gold Tokens",
        id: "redeemGoldTokens_Poker.text"
    },
    nightlyLimitRestrictionPopupTitle: {
        defaultMessage: "Safer Gambling Message",
        id: "nightlyLimitRestriction.popup.title.text"
    },
    nightlyLimitRestrictionPopupContent: {
        defaultMessage: "We see that your activity hasn't slowed down. Please understand we are committed to ensuring your experience here is not just fun but also safe.\n\nA temporary restriction has been placed on your account so you will not be able to login for the next 12 hours.\n\nWe've sent you an email with more information about the restriction and the available responsible gaming tools and controls.",
        id: "nightlyLimitRestriction.popup.content.text"
    },
    nightlyLimitRestrictionPopupButton: {
        defaultMessage: "GOT IT",
        id: "nightlyLimitRestriction.popup.button.text"
    },
    nightlyLimitRestrictionPopupTitle_Poker: {
        defaultMessage: "Safer Gambling Message",
        id: "nightlyLimitRestriction_poker.popup.title.text"
    },
    nightlyLimitRestrictionPopupContent_Poker: {
        defaultMessage: "We see that your activity hasn't slowed down. Please understand we are committed to ensuring your experience here is not just fun but also safe. \n\nA temporary restriction has been placed on your account so you will not be able to continue playing or placing bets for the next 12 hours. Please note that if you've already registered, qualified or joined a tournament, you can still play in the tournament without adding any additional funds. \n\n We've sent you an email with more information about the restriction and the available responsible gaming tools and controls.",
        id: "nightlyLimitRestriction_poker.popup.content.text"
    },
    nightlyLimitRestrictionPopupButton_Poker: {
        defaultMessage: "GOT IT",
        id: "nightlyLimitRestriction_poker.popup.button.text"
    },
    nightlyLimitRestrictedPopupTitle: {
        defaultMessage: "Safer Gambling Message",
        id: "nightlyLimitRestricted.popup.title.text"
    },
    nightlyLimitRestrictedPopupContent: {
        defaultMessage: "The temporary restriction is still active and will be removed on {expirationDate} starting from {expirationTime}.\n\nPlease log out and log in again after the restriction is removed.",
        id: "nightlyLimitRestricted.popup.content.text"
    },
    nightlyLimitRestrictedPopupButton: {
        defaultMessage: "GOT IT",
        id: "nightlyLimitRestricted.popup.button.text"
    },
    tryAgain: {
        defaultMessage: "Try Again",
        id: "tryAgain.text"
    },
    geolocationVerifyLocationTitle: {
        defaultMessage: "Verify Your Location",
        id: "geolocationVerifyLocationTitle.text"
    },
    geolocationVerifyLocationContent: {
        defaultMessage: "We were unable to verify your location. Please click TRY AGAIN to verify your location or contact us if the problem persists.",
        id: "geolocationVerifyLocationContent.text"
    },
    GeolocationRetryInProgressPopupP1: {
        defaultMessage: "Verifying...",
        id: "geolocationRetryInProgress.popup.p1.text"
    },
    GeolocationRetryInProgressPopupP2: {
        defaultMessage: "Please wait a few moments while we verify your location",
        id: "geolocationRetryInProgress.popup.p2.text"
    },
    PokerDownloadPokerPopUpTitle: {
        defaultMessage: "Download Poker",
        id: "PokerDownloadPopUpTitle.text"
    },
    PokerDownloadPopUp: {
        defaultMessage: "\"Download\"",
        id: "PokerDownloadPopUp.text"
    },
    PokerDownloadPopUpInstallationBoxP1: {
        defaultMessage: "Already clicked the \"Download\" button ?",
        id: "PokerDownloadPopUpInstallationBox.p1.text"
    },
    PokerDownloadPopUpInstallationBoxP2: {
        defaultMessage: "you should see the",
        id: "PokerDownloadPopUpInstallationBox.p2.text"
    },
    PokerDownloadPopUpInstallationBoxP3: {
        defaultMessage: "installation box",
        id: "PokerDownloadPopUpInstallationBox.p3.text"
    },
    PokerDownloadPopUpInstallationBoxP4: {
        defaultMessage: "in the lower left corner of the screen.",
        id: "PokerDownloadPopUpInstallationBox.p4.text"
    },
    PokerDownloadPopUpInstallationBoxP5: {
        defaultMessage: "Open it and click the \"Run\".",
        id: "PokerDownloadPopUpInstallationBox.p5.text"
    },
    PokerDownloadPopUpInstallationBoxP6: {
        defaultMessage: "Can't see the installation dialog ? Click\n",
        id: "PokerDownloadPopUpInstallationBox.p6.text"
    },
    PokerDownloadPopUpInstallationBoxP7: {
        defaultMessage: "\n again to restart software installation.",
        id: "PokerDownloadPopUpInstallationBox.p7.text"
    },
    PokerDownloadPopUpNext: {
        defaultMessage: "Next",
        id: "PokerDownloadPopUpNext.text"
    },
    PokerDownloadPopUpCreateAccountP1: {
        defaultMessage: "Create Account",
        id: "PokerDownloadPopUpCreateAccount.p1.text"
    },
    PokerDownloadPopUpCreateAccountP2: {
        defaultMessage: "Already have an account ?",
        id: "PokerDownloadPopUpCreateAccount.p2.text"
    },
    PokerDownloadPopUpCreateAccountP3: {
        defaultMessage: "Just complete the download and start playing!",
        id: "PokerDownloadPopUpCreateAccount.p3.text"
    },
    PokerDownloadPopUpCreateAccountP4: {
        defaultMessage: "If you don’t have an account yet",
        id: "PokerDownloadPopUpCreateAccount.p4.text"
    },
    PokerDownloadPopUpCreateAccountP5: {
        defaultMessage: ", simply",
        id: "PokerDownloadPopUpCreateAccount.p5.text"
    },
    PokerDownloadPopUpCreateAccountP6: {
        defaultMessage: "create",
        id: "PokerDownloadPopUpCreateAccount.p6.text"
    },
    PokerDownloadPopUpCreateAccountP7: {
        defaultMessage: "one after launching the software.",
        id: "PokerDownloadPopUpCreateAccount.p7.text"
    },
    PokerDownloadPopUpBack: {
        defaultMessage: "Back",
        id: "PokerDownloadPopUpBack.text"
    },
    PokerDownloadPopUpStartPlayingP1: {
        defaultMessage: "Start Playing !",
        id: "PokerDownloadPopUpStartPlaying.p1.text"
    },
    PokerDownloadPopUpStartPlayingP2: {
        defaultMessage: "With a wide range of exciting tournaments, exciting cash games, Sit & Go Jackpot tournaments and exciting promotions, we are all set to play!",
        id: "PokerDownloadPopUpStartPlaying.p2.text"
    },
    PokerDownloadPopUpClose: {
        defaultMessage: "Close",
        id: "PokerDownloadPopUpClose.text"
    },
    DownloadAppPopUpTitle: {
        defaultMessage: "Download The App",
        id: "DownloadAppPopUpTitle.text"
    },
    DownloadAppPopUpP1: {
        defaultMessage: "Play in our app",
        id: "DownloadAppPopUp.p1.text"
    },
    DownloadAppPopUpP2: {
        defaultMessage: "To log in from your mobile device, you must download the app.",
        id: "DownloadAppPopUp.p2.text"
    },
    LogoutLugasPopupContent: {
        defaultMessage: "By logging out you will not be able to place bets for five minutes.",
        id: "logout.lugas.content.text"
    },
    LogoutLugasTitle: {
        defaultMessage: "Logout",
        id: "logout.lugas.title.text"
    },
    NewPlatformPopupTitle: {
        defaultMessage: "PLATFORMĂ NOUĂ",
        id: "NewPlatformPopupTitle.text"        
    },
    NewPlatformPopupP1: {
        defaultMessage: "Experimentează distracția la un alt nivel cu noua noastră platformă",
        id: "NewPlatformPopupTitle.p1.text"
    },
    NewPlatformPopupP2: {
        defaultMessage: "Un bonus ar putea să te aștepte în noua noastră aplicație!",
        id: "NewPlatformPopupTitle.p2.text"
    },
    NewPlatformPopupP3: {
        defaultMessage: "Accesează noua platformă și conectează-te cu același utilizator și parolă",
        id: "NewPlatformPopupTitle.p3.text"
    },
    NewPlatformButtonLink : {
        defaultMessage: "Du-mă acolo",
        id: "NewPlatformButtonLink.text"
    },
    casinoDailyWish:{
        defaultMessage: "Daily Wish",
        id:"homeSection.casino.daily-wish.text"
    },
    MyAccountAreaHeaderTitle: {
        defaultMessage: "My Account",
        id: "myAccountHeader.title.text"
    },
    AppVersion: {
        defaultMessage: "App version",
        id: "app.version.text"
    },
    GameHistory: {
        defaultMessage: "Game History",
        id: "gameHistory.text"
    },
    CurrentBalance: {
        defaultMessage: "Current Balance",
        id: "current.balance.text"
    },
    Cash: {
        defaultMessage: "Cash",
        id: "cash.text"
    },
    FreeBets: {
        defaultMessage: "Free Bets",
        id: "free.bets.text"
    },
    Bonus: {
        defaultMessage: "Bonus",
        id: "bonus.text"
    },
    UploadDocumentsLink: {
        defaultMessage: "Upload Documents",
        id: "upload.documents.link.text"
    },
    Security: {
        defaultMessage: "Security",
        id: "security.link.text"
    },
    Settings: {
        defaultMessage: "Settings",
        id: "settings.text"
    },
    SettingsCountry: {
        defaultMessage: "Country",
        id: "settings.country.text"
    },
    SettingsNotifications: {
        defaultMessage: "Notifications",
        id: "settings.notifications.text"
    },
    SettingsNotificationsDescription: {
        defaultMessage: "Manage",
        id: "settings.notifications.description.text"
    },
    SettingsSelect: {
        defaultMessage: "Select",
        id: "settings.select.text"
    },
    controlCenterMyAccArea: {
        defaultMessage: "Control Center",
        id: "myAccAreaControlCenter.link.text"
    },
    bonuses: {
        defaultMessage: "Bonuses",
        id: "bonuses.text"
    },
    bonusesBelowText: {
        defaultMessage: "Bonuses can be granted from special promotional offers and are subject to the promotion's terms",
        id: "bonusesBelowText.text"
    },
    freePlay: {
        defaultMessage: "Free Play",
        id: "freePlay.text"
    },
    freePlayBelowText: {
        defaultMessage: "Free Play Vouchers are available on Casino and award specific amounts of money that can be played on a selected range of games",
        id: "freePlayBelowText.text"
    },
    freeBets: {
        defaultMessage: "Free Bets",
        id: "freeBets.text"
    },
    freeBetsBelowtext: {
        defaultMessage: "Free Bets are available in specific amounts and can be used directly from the betslip for select sports markets",
        id: "freeBetsBelowtext.text"
    },
    tournamentTickets: {
        defaultMessage: "Tournament Tickets",
        id: "tournamentTickets.text"
    },
    tournamentTicketsBelowtext: {
        defaultMessage: "Tournament Tickets are virtual vouchers that players may use to join selected Poker tournaments",
        id: "tournamentTicketsBelowtext.text"
    },
    SIvouchers: {
        defaultMessage: "SI Voucher",
        id: "SIvouchers.text"
    },
    SIvouchersBelowtext: {
        defaultMessage: "SI Gift Codes are gift codes rewarded to a player to be redeemed for rewards from our partner channel, SI Covers",
        id: "SIvouchersBelowtext.text"
    },
    bottomNavigationHome: {
            defaultMessage: "Home",
            id: "bottomNavHome.text"
    },
    bottomNavigationInPlay: {
        defaultMessage: "In-Play",
        id: "bottomNavInPlay.text"
    },
    bottomNavigationMyBets: {
        defaultMessage: "My Bets",
        id: "bottomNavMyBets.text"
    },
    bottomNavigationFootball: {
        defaultMessage: "Football",
        id: "bottomNavFootball.text"
    },
    bottomNavigationCasino: {
        defaultMessage: "Casino",
        id: "bottomNavCasino.text"
    },
    casinoSessionSummaryLogout: {
        defaultMessage: "Logout",
        id: "casinoSessionSummary.text"
    },
    sessionDuration: {
        defaultMessage: "Session duration",
        id: "sessionDuration.text"
    },
    profitAndLossSummary: {
        defaultMessage: "Profit and loss summary",
        id: "profitAndLossSummary.text"
    },
    totalBets: {
        defaultMessage: "Total bets",
        id: "totalBets.text"
    },
    casinoSessionSummaryPopupTitle: {
        id: "casinoSessionSummaryPopup.title.text"
    },
    perfect10: {
        defaultMessage: "Perfect 10",
        id: "perfect10.text"
    },
});